import DISABLE_REASONS from '@integrations/pint-appstore-commons/src/enums/DISABLE_REASONS.json';
import translations from '../../translations';

export default function getTextForAppDisableReason(reasons, isUserAdmin) {
    if (reasons.length === 1) {
        if (reasons.includes(DISABLE_REASONS.ONLY_ADMIN)) {
            return translations.disableAppExplanations.askAdminToEnable;
        }
        if (reasons.includes(DISABLE_REASONS.ONLY_ADMIN_OR_POWER)) {
            return translations.disableAppExplanations.askToBecomePower;
        }
        if (!isUserAdmin && reasons.includes(DISABLE_REASONS.UPDATE_PLAN)) {
            // power user does not throw for ONLY_ADMIN_OR_POWER, but throws for UPDATE_PLAN
            return translations.disableAppExplanations.askAdminToUpgrade;
        }
        // includes UPDATE_PLAN

        return translations.disableAppExplanations.upgradeAsAdmin;
    }
    // assumption - includes UPDATE_PLAN and any other one

    return translations.disableAppExplanations.askAdminToUpgrade;
}
